import axios from 'axios';

import { AUTH_USER, UNAUTH_USER } from './types';

import { API_URL } from '../config/environment-variables';
import { ENTITY_NOT_FOUND } from '../utils/api-errors-const';

import { apiError, apiSuccessMessage } from './utils-actions';
import { USER_SETTINGS_URL } from '../utils/redirect-const';


function handleLoginResponse(response, dispatch, history) {
  const role = response.data.role;
  localStorage.setItem('token', response.data.token);
  localStorage.setItem('role', role);
  
  dispatch({
    type: AUTH_USER,
    payload: role,
  });

  
  if (history) {
    history.push(USER_SETTINGS_URL);
  }
}

export function login(values, form) {
  const { username, password } = values;
  return dispatch => axios.post(`${API_URL}/auth/token`, { username, password})
    .then(response => handleLoginResponse(response, dispatch))
    .catch(error => {
      form.setSubmitting(false);
      switch (error.response.status) {
        case 401:
          const formattedError = 'Invalid email or password';
          form.setErrors({ username: formattedError, password: formattedError });
          default:
              console.warn(`Unhandled action type`);
      }
    });
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  
  return { type: UNAUTH_USER };
}

export function requestResetPassword(details, form) {
  return dispatch => axios.post(`${API_URL}/user/password/reset`, details)
    .then(() => dispatch(apiSuccessMessage()))
    .catch(error => {
      form.setSubmitting(false);
      const errorGroup = error.response.data && error.response.data.serviceErrorGroup;
      switch (errorGroup) {
        case ENTITY_NOT_FOUND:
          const formattedError = 'Email not found or account is not active.';
          form.setErrors({ username: formattedError, password: formattedError });
           default:
                        console.warn(`Unhandled action type`);
                    }
    });
}

export function requestChangePassword(values) {
  return dispatch => axios.post(`${API_URL}/user/password/change`, values)
    .then((response) => handleLoginResponse(response, dispatch))
    .catch(response => dispatch(apiError('Unable to change password.', response)));
}

export function googleLogin(credential) {
  return dispatch => axios.post(`${API_URL}/auth/google`, { credential })
    .then(response => handleLoginResponse(response, dispatch))
    .catch(error => {
      console.error('Google login failed:', error);
      dispatch(apiError('Google login failed. Please try again.'));
    });
}
